"use strict";
exports.__esModule = true;
exports.useBlocksContext = exports.BlocksContext = exports.useEditorContext = exports.EditorContext = void 0;
var _a = window.MTBlockEditor.Context, EditorContext = _a.EditorContext, useEditorContext = _a.useEditorContext, BlocksContext = _a.BlocksContext, useBlocksContext = _a.useBlocksContext;
exports.EditorContext = EditorContext;
exports.useEditorContext = useEditorContext;
exports.BlocksContext = BlocksContext;
exports.useBlocksContext = useBlocksContext;
